import Definitions from "../../http_request/Model/Definitions/Definitions";
import {toast} from "react-toastify";

export const getFilterBranch = (setFilterBranch, setLoading) => {
    Definitions.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (data) => {
            setFilterBranch(data)
        },
        error: ({error}) => {
            toast.error(error.data.message);
        },
        final: (data) => {
            setLoading(data);
        },
    }).FilterBranch();
};
